var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var TableRow = styled.tr(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var templateObject_1;
